import { toQueryString } from "./serialiseUtils";
import { STATUS_SUCCESS } from "../Settings/constants/index";

/**
 * Api service that includes anti-forgery token.
 * @param {string} - request url
 * @param {data[]} - data object for request
 * @param {rendering[]} - rendering object with anti-forgery token
 * @returns {Promise} return response from request
 */
export const userDataApiCall = (url, rendering, data = {}) => {
  const {
    antiForgeryToken
  } = rendering;
  if (typeof antiForgeryToken === "undefined") {
    return Promise.reject("Anti-forgery field not present.");
  }
  data[antiForgeryToken.name] = antiForgeryToken.value; // Add anti-forgery token to all requests

  return fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded"
    },
    credentials: "include",
    // Required to send anti-forgery cookie
    method: "POST",
    body: toQueryString(data)
  }).then(response => {
    if (response.status !== STATUS_SUCCESS) {
      return Promise.reject(response);
    }
    return response.json();
  }).catch(e => {
    return Promise.reject(e.status);
  });
};

/**
 * Api service that includes anti-forgery token.
 * @param {string} - request url
 * @param {data[]} - data object for request
 * @param {rendering[]} - rendering object with anti-forgery token
 * @returns {Promise} return response from request
 */
export const fetchResolverWithToken = (url, rendering, data = {}) => {
  const {
    antiForgeryToken
  } = rendering;
  if (typeof antiForgeryToken === "undefined") {
    return Promise.reject("Anti-forgery field not present.");
  }
  data[antiForgeryToken.name] = antiForgeryToken.value; // Add anti-forgery token to all requests

  return fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded"
    },
    credentials: "include",
    // Required to send anti-forgery cookie
    method: "POST",
    body: toQueryString(data)
  }).then(response => {
    if (response.status !== STATUS_SUCCESS) {
      return Promise.reject(response);
    }
    return response.json();
  }).catch(response => {
    return response.json().then(data => {
      return Promise.reject(data);
    });
  });
};

/**
 * Api service helper.
 * @param {string} - request url
 * @param {data[]} - data object for request
 * @returns {Promise} return response from request
 */
export const fetchResolver = (url, data = {}) => {
  return fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify(data)
  }).then(response => {
    if (response.status !== STATUS_SUCCESS) {
      return Promise.reject(`${response.status} - ${response.statusText}`);
    }
    return response.json();
  });
};